// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/overlay/index.css
// module id = 868
// module chunks = 148